import React from 'react';
import { Calendar, Lock, Sparkles } from 'lucide-react';
import GigCard from './GigCard';

export default function GigsList({
  gigs,
  isPremium,
  expandedGig,
  onToggleExpand,
  onDeleteGig,
  onSetlistUpload,
  onPhotoUpload,
  onDeletePhoto,
  loading,
  isMobile
}) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const upcomingGigs = gigs.filter(g => new Date(g.date) >= today);
  const pastGigs = gigs.filter(g => new Date(g.date) < today).reverse();

  return (
    <div className="card-3d rounded-card p-4 sm:p-6">
      <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
        <Calendar className="w-5 h-5 text-white" />
        Gigs ({gigs.length})
      </h2>

      {gigs.length === 0 ? (
        <div className="text-center py-8">
          <Calendar className="w-12 h-12 mx-auto mb-3 text-text-subtle opacity-50" />
          <p className="text-text-muted">No gigs yet</p>
          <p className="text-sm text-text-subtle">Add your first gig above</p>
        </div>
      ) : (
        <>
          {/* Upcoming Gigs */}
          {upcomingGigs.length > 0 && (
            <div className="mb-8">
              <h3 className="text-lg font-semibold mb-4 text-brand flex items-center gap-2">
                <Calendar className="w-5 h-5" />
                Upcoming Gigs
                {!isPremium && <Lock className="w-4 h-4 text-yellow-400" />}
              </h3>

              {!isPremium && (
                <div className="bg-gradient-to-r from-yellow-900/30 to-orange-900/30 border border-yellow-700/50 rounded-card p-4 mb-4">
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                    <Lock className="w-5 h-5 text-yellow-400 flex-shrink-0" />
                    <div className="flex-1">
                      <p className="text-yellow-200 text-sm">
                        Upcoming gigs are locked for free accounts. Upgrade to Premium to track and manage your upcoming gigs.
                      </p>
                    </div>
                    <button
                      onClick={() => window.location.hash = '#settings'}
                      className="bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-slate-900 font-bold py-2 px-4 transition flex items-center gap-2 text-sm whitespace-nowrap rounded-pill"
                    >
                      <Sparkles className="w-4 h-4" />
                      Upgrade
                    </button>
                  </div>
                </div>
              )}

              {isPremium && (
                <div className="space-y-3">
                  {upcomingGigs.map(gig => (
                    <GigCard
                      key={gig.id}
                      gig={gig}
                      isExpanded={expandedGig === gig.id}
                      onToggleExpand={() => onToggleExpand(gig.id)}
                      onDelete={onDeleteGig}
                      onSetlistUpload={onSetlistUpload}
                      onPhotoUpload={onPhotoUpload}
                      onDeletePhoto={onDeletePhoto}
                      loading={loading}
                      isMobile={isMobile}
                      isPast={false}
                    />
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Past Gigs */}
          {pastGigs.length > 0 && (
            <div>
              <h3 className="text-lg font-semibold mb-4 text-text-subtle flex items-center gap-2">
                <Calendar className="w-5 h-5" />
                Past Gigs
              </h3>
              <div className="space-y-3">
                {pastGigs.map(gig => (
                  <GigCard
                    key={gig.id}
                    gig={gig}
                    isExpanded={expandedGig === gig.id}
                    onToggleExpand={() => onToggleExpand(gig.id)}
                    onDelete={onDeleteGig}
                    onSetlistUpload={onSetlistUpload}
                    onPhotoUpload={onPhotoUpload}
                    onDeletePhoto={onDeletePhoto}
                    loading={loading}
                    isMobile={isMobile}
                    isPast={true}
                  />
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
